<template>
  <div class="form-group">
    <p>Búsqueda de Estudios
    <multiselect
      v-model="selectedEstudio"
      :options="searchResults"
      label="nombre_busqueda"
      track-by="id"
      placeholder="Ingresa el nombre del estudio"
      @search-change="searchEstudios"
      @select="selectEstudio"
      :loading="isLoading"
      :clear-on-select="true"
      :close-on-select="true"
      :allow-empty="false"
    >
    </multiselect>
  </p>
  </div>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect';
var config = require("@/config/api.json");
const API = config.api;

export default {
  name: "SearchEstudios",
  components: { Multiselect },
  data() {
    return {
      searchValue: '',
      searchResults: [],
      selectedEstudio: null,
      isLoading: false
    };
  },
  props: {
    mainId: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    async searchEstudios(query) {
      console.log('Buscando estudios...', this.mainId, query);
      if (query.trim() === '') {
        this.searchResults = [];
        return;
      }
      this.isLoading = true;
      try {
        const response = await axios.post(`${API}/busqueda_tipos_estudios`, {
          params: {
            searchValue: query,
            personal_medico_id: this.mainId
          }
        });
        console.log(response.data);
        this.searchResults = response.data;
      } catch (error) {
        console.error(error);
        this.$emit('notify', 'error', `Error: ${error.message}`);
      } finally {
        this.isLoading = false;
      }
    },
    selectEstudio(estudio) {
      console.log(estudio);
      this.searchResults = [];
      this.$emit('select', estudio);
      setTimeout(() => {
        this.selectedEstudio = null;
      }, 1000);
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.autocomplete-results {
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.autocomplete-results li {
  padding: 8px;
  cursor: pointer;
}

.autocomplete-results li:hover {
  background-color: #f0f0f0;
}
</style>
